module.exports = __webpack_public_path__ + "img/banner-2.e6244c2a.jpg";